import { faPencil, faPlus, faTrash } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useEffect, useState } from "react";
import {
  Breadcrumb,
  Button,
  Col,
  Container,
  Form,
  Modal,
  Row,
} from "react-bootstrap";
import ReactLoading from "react-loading";
import Datatable from "../widget/table/Datatable";
import {
  createCompanyManager,
  deleteCompanyManager,
  getAllCompanyManager,
  getCompanyManagerById,
  updateCompanyManager,
} from "../service/companyManager";
import { toast } from "react-toastify";
import { currentUser } from "../helpers";
import Swal from "sweetalert2";
import { updateStatusofUser } from "../service/userManagement";

export default function CompanyManager() {
  const userInfo = currentUser();
  const CompanyAdminId = userInfo?.userId;
  const companyNameofManager = userInfo?.companyName;
  console.log(companyNameofManager, "Data989");
  const initialValues = {
    firstName: "",
    lastName: "",
    mobile: "",
    email: "",
    password: "",
    companyName: companyNameofManager,
    address1: "",
    address2: "",
    province: "",
    city: "",
    postalCode: "",
    country: "",
  };
  const [loader, setLoader] = useState(false);
  const [Modalshow1, setModalshow1] = useState(false);

  const handleClose1 = () => {
    setModalshow1(false);
    setFormValues(initialValues);
    setErrors({});
  };

  const handleShow = () => setModalshow1(true);
  const [errors, setErrors] = useState({});
  const [formValues, setFormValues] = useState(initialValues);

  const [data, setData] = useState([]);
  const {
    firstName,
    lastName,
    mobile,
    email,
    password,
    companyName,
    address1,
    address2,
    province,
    city,
    postalCode,
    country,
  } = formValues;

  const handleChange = (e) => {
    const { name, value } = e.target;
    console.log(`Changing ${name} to ${value}`, "Data98989");
    setFormValues({
      ...formValues,
      [name]: value,
    });
    if (errors[name]) {
      setErrors((prevErrors) => ({ ...prevErrors, [name]: false }));
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const isValid = validateForm();

    if (isValid) {
      setLoader(true);
      try {
        let response = null;
        const obj = {
          firstName: formValues.firstName,
          lastName: formValues.lastName,
          companyName: formValues.companyName,
          email: formValues.email,
          mobile: formValues.mobile,
          subscriptionPayment: formValues.subscriptionPayment,
          userLimit: formValues.userLimit,
          subscriptionDuration: formValues.subscriptionDuration,
        };
        if (formValues.password) {
          obj.password = formValues.password;
        }
        if (formValues.address1) obj.address1 = formValues.address1;
        if (formValues.address2) obj.address2 = formValues.address2;
        if (formValues.province) obj.province = formValues.province;
        if (formValues.city) obj.city = formValues.city;
        if (formValues.postalCode) obj.postalCode = formValues.postalCode;
        if (formValues.country) obj.country = formValues.country;

        if (formValues.id) {
          obj.id = formValues.id;

          response = await updateCompanyManager(obj);
          toast.success("Company Manager is updated successfully!", {
            autoClose: 3000,
          });
        } else {
          response = await createCompanyManager(obj);
          if (!response?.status) {
            toast.error(response?.response?.data?.message);
          } else {
            toast.success("Company Manager is added successfully!");
          }
        }
        if (response) {
          getAllCompanyManagers();
          setFormValues(initialValues);
          handleClose1();
        }
      } catch (error) {
        console.error("Error submitting form:", error);
      } finally {
        setTimeout(() => {
          setLoader(false);
        }, 3000);
      }
    }
  };
  const validateForm = () => {
    const newErrors = {};
    if (!firstName) {
      newErrors.firstName = "Enter your First name";
    }
    if (!lastName) {
      newErrors.lastName = "Enter your Last name";
    }

    if (!mobile) {
      newErrors.mobile = "Enter your mobile number";
    } else if (!/^\d{10}$/.test(mobile)) {
      newErrors.mobile = "Phone number must be exactly 10 digits";
    }
    if (!email) {
      newErrors.email = "Enter your email";
    }
    if (!formValues.id) {
      if (!password) {
        newErrors.password = "Enter your Password";
      } else if (password.length < 8) {
        newErrors.password = "Password must be at least 8 characters";
      } else if (!/\d/.test(password)) {
        newErrors.password = "Password must contain at least one digit";
      } else if (!/[!@#$%^&*(),.?":{}|<>]/.test(password)) {
        newErrors.password =
          "Password must contain at least one special character";
      }
    }
    if (!companyName) {
      newErrors.companyName = "Enter Company";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const columns = [
    {
      name: "Manager Name",
      selector: (row) => row.managerNAme,
      sortable: true,
    },
    {
      name: "Email",
      selector: (row) => row.email,
      sortable: true,
    },
    {
      name: "Phone",
      selector: (row) => row.mobile,
    },
    {
      name: "Company",
      selector: (row) => row.companyName,
      sortable: true,
    },
    {
      name: "Status",
      selector: (row) => row.isActive,
      cell: (row) => (
        <Button
          variant={
            row.isActive === false
              ? "outline-danger"
              : row.isActive === true
              ? "outline-success"
              : "outline-info"
          }
          onClick={() => handleStatusChange(row)}
        >
          {row.isActive ? "Active" : "Inactive"}
        </Button>
      ),
    },

    {
      name: "Actions",
      cell: (row) => (
        <div className="actionBtngroup">
          <Button variant="" onClick={() => handleEdit(row.id)}>
            <FontAwesomeIcon icon={faPencil} />
          </Button>
          <Button variant="" onClick={() => handleDelete(row.id)}>
            <FontAwesomeIcon icon={faTrash} />
          </Button>
        </div>
      ),
    },
  ];
  const handleStatusChange = async (row) => {
    let statuscode = !row.isActive;

    const updatedStatus = await updateStatusofUser(row.id, statuscode);
    if (updatedStatus) {
      setData((prevData) =>
        prevData.map((user) =>
          user.id === row.id ? { ...user, isActive: statuscode } : user
        )
      );

      if (updatedStatus.data) {
        toast.success("User activated successfully!", { autoClose: 3000 });
      } else {
        toast.error("User deactivated successfully!", { autoClose: 3000 });
      }
    } else {
      toast.error("Failed to update user status.", { autoClose: 3000 });
    }
  };

  useEffect(() => {
    getAllCompanyManagers();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  const getAllCompanyManagers = async () => {
    const result = await getAllCompanyManager(CompanyAdminId);
    let filteredData = result?.data.map((companyManager) => {
      return {
        ...companyManager,
        managerNAme: `${companyManager.firstName} ${companyManager.lastName}`,
      };
    });
    setData(filteredData);
  };

  const handleEdit = async (id) => {
    try {
      let data = await getCompanyManagerById(id);
      if (data?.status) {
        setFormValues({
          ...formValues,
          id: data.data.id ?? id,
          firstName: data.data.firstName,
          lastName: data.data.lastName,
          companyName: data.data.companyName,
          email: data.data.email,
          mobile: data.data.mobile,
          password: data.data.password,
          subscriptionPayment: data.data.subscriptionPayment,
          userLimit: data.data.userlimit,
          subscriptionDuration: data.data.subscriptionDuration,
          address1: data.data.address1,
          address2: data.data.address2,
          province: data.data.province,
          city: data.data.city,
          postalCode: data.data.postalCode,
          country: data.data.country,
        });
        setModalshow1(true);
      } else {
      }
    } catch (error) {
      console.error("Error occurred while editing:", error);
    }
  };
  const handleDelete = async (id) => {
    try {
      console.log("Delete clicked for ID:", id);
      const { isConfirmed } = await Swal.fire({
        title: "Are you sure?",
        text: "This action cannot be undone!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#d33",
        cancelButtonColor: "#3085d6",
        confirmButtonText: "Yes, delete it!",
      });

      if (isConfirmed) {
        const response = await deleteCompanyManager(id);
        if (response) {
          await getAllCompanyManagers();
          Swal.fire("Deleted!", response?.message, "success");
        } else {
          Swal.fire("Error!", "Failed to delete Company Admin.", "error");
        }
      }
    } catch (error) {
      console.error("Error submitting form:", error);
    }
  };

  return (
    <Container fluid className="p-0 my-3  ">
      <div className="d-flex justify-content-between align-items-center ">
        {" "}
        <div>
          <Breadcrumb>
            <Breadcrumb.Item href="/AdditionalRevenue">
              Comapny Manager
            </Breadcrumb.Item>
          </Breadcrumb>
        </div>
        <div>
          <Button className="btn custom-btn mb-3 border-0" onClick={handleShow}>
            <FontAwesomeIcon icon={faPlus} /> Add Manager
          </Button>
        </div>
      </div>
      <Row>
        <Col md={12}>
          <div className="border-0 p-3 rounded card">
            <div className="title-container">
              <p>Manager List</p>
            </div>
            <Datatable columns={columns} data={data} />
          </div>
        </Col>
      </Row>

      {/* Add Customer Modal Start*/}
      <Modal show={Modalshow1} onHide={handleClose1} centered size="lg">
        <form onSubmit={handleSubmit}>
          <Modal.Header closeButton className="border-0">
            <Modal.Title>
              {" "}
              {formValues.id ? "Update Manager" : "Add Manager"}
            </Modal.Title>
          </Modal.Header>
          <Modal.Body className="pb-0">
            <div className="custom_form mb-4 position-relative">
              <h6>Manager Info</h6>
              <Row>
                <Col md={6}>
                  <Form.Group>
                    <Form.Label>First Name</Form.Label>
                    <Form.Control
                      type="text"
                      name="firstName"
                      value={firstName}
                      onChange={handleChange}
                      className={`px-3 ${
                        errors.firstName ? "border-danger mb-0" : ""
                      }`}
                      placeholder="Enter First name"
                    />
                    {errors.firstName && (
                      <Form.Text className="text-danger">
                        Enter your firstName
                      </Form.Text>
                    )}
                  </Form.Group>
                </Col>
                <Col md={6}>
                  <Form.Group>
                    <Form.Label>Last Name</Form.Label>
                    <Form.Control
                      type="text"
                      name="lastName"
                      value={lastName}
                      onChange={handleChange}
                      className={`px-3 ${
                        errors.lastName ? "border-danger mb-0" : ""
                      }`}
                      placeholder="Enter Last name"
                    />
                    {errors.lastName && (
                      <Form.Text className="text-danger">
                        Enter your last Name
                      </Form.Text>
                    )}
                  </Form.Group>
                </Col>
                <Col md={6}>
                  <Form.Group>
                    <Form.Label>Email</Form.Label>
                    <Form.Control
                      type="email"
                      name="email"
                      value={email}
                      onChange={handleChange}
                      className={`px-3 ${
                        errors.email ? "border-danger mb-0" : ""
                      }`}
                      placeholder="xyz@info.com"
                    />
                    {errors.email && (
                      <Form.Text className="text-danger">
                        Enter your email
                      </Form.Text>
                    )}
                  </Form.Group>
                </Col>
                <Col md={6}>
                  <Form.Group>
                    <Form.Label>Password</Form.Label>
                    <Form.Control
                      type="password"
                      name="password"
                      value={password}
                      onChange={handleChange}
                      className={`px-3 ${
                        errors.password ? "border-danger mb-0" : ""
                      }`}
                      placeholder="Enter Password"
                    />
                    {errors.password && (
                      <Form.Text className="text-danger">
                        Enter Password
                      </Form.Text>
                    )}
                  </Form.Group>
                </Col>

                <Col md={6}>
                  <Form.Group>
                    <Form.Label>Company Name</Form.Label>
                    <Form.Control
                      type="text"
                      name="companyName"
                      value={companyName}
                      onChange={handleChange}
                      className={`px-3 ${
                        errors.companyName ? "border-danger mb-0" : ""
                      }`}
                      placeholder="Company Name"
                    />
                    {errors.companyName && (
                      <Form.Text className="text-danger">
                        Enter your Company
                      </Form.Text>
                    )}
                  </Form.Group>
                </Col>
                <Col md={6}>
                  <Form.Group>
                    <Form.Label>Phone</Form.Label>
                    <Form.Control
                      type="mobile"
                      name="mobile"
                      value={mobile}
                      onChange={handleChange}
                      className={`px-3 ${
                        errors.mobile ? "border-danger mb-0" : ""
                      }`}
                      placeholder="+1 (751) 505-4112"
                      onKeyPress={(e) => {
                        if (!/^\d$/.test(e.key)) {
                          e.preventDefault();
                        }
                      }}
                    />
                    {errors.mobile && (
                      <Form.Text className="text-danger">
                        {errors.mobile === "Enter your number"
                          ? "Enter your number"
                          : "Phone number must be exactly 10 digits"}
                      </Form.Text>
                    )}
                  </Form.Group>
                </Col>
              </Row>
            </div>
            <div className="custom_form mb-4 position-relative ">
              <h6>Manager Address</h6>
              <Row>
                <Col md={6}>
                  <Form.Group>
                    <Form.Label>Address 1</Form.Label>
                    <Form.Control
                      type="text"
                      name="address1"
                      value={address1}
                      onChange={handleChange}
                      className={`px-3 ${
                        errors.address1 ? "border-danger mb-0" : ""
                      }`}
                      placeholder="Enter Address 1"
                    />
                    {errors.address1 && (
                      <Form.Text className="text-danger">
                        Enter your address
                      </Form.Text>
                    )}
                  </Form.Group>
                </Col>
                <Col md={6}>
                  <Form.Group>
                    <Form.Label>Address 2</Form.Label>
                    <Form.Control
                      type="text"
                      name="address2"
                      value={address2}
                      onChange={handleChange}
                      className={`px-3 ${
                        errors.address2 ? "border-danger mb-0" : ""
                      }`}
                      placeholder="Enter Address 2"
                    />
                    {errors.address2 && (
                      <Form.Text className="text-danger">
                        Enter your address2
                      </Form.Text>
                    )}
                  </Form.Group>
                </Col>

                <Col md={6}>
                  <Form.Group>
                    <Form.Label>State</Form.Label>
                    <Form.Control
                      type="text"
                      name="province"
                      value={province}
                      onChange={handleChange}
                      className={`px-3 ${
                        errors.province ? "border-danger mb-0" : ""
                      }`}
                      placeholder="Enter State"
                    />
                    {errors.province && (
                      <Form.Text className="text-danger">
                        Enter your State
                      </Form.Text>
                    )}
                  </Form.Group>
                </Col>
                <Col md={6}>
                  <Form.Group>
                    <Form.Label>City</Form.Label>
                    <Form.Control
                      type="text"
                      name="city"
                      value={city}
                      onChange={handleChange}
                      className={`px-3 ${
                        errors.city ? "border-danger mb-0" : ""
                      }`}
                      placeholder="Enter City"
                    />
                    {errors.city && (
                      <Form.Text className="text-danger">
                        Enter your city
                      </Form.Text>
                    )}
                  </Form.Group>
                </Col>
                <Col md={6}>
                  <Form.Group>
                    <Form.Label>Postal Code</Form.Label>
                    <Form.Control
                      type="text"
                      name="postalCode"
                      value={postalCode}
                      onChange={handleChange}
                      className={`px-3 ${
                        errors.postalCode ? "border-danger mb-0" : ""
                      }`}
                      placeholder="Enter Postal Code"
                    />
                    {errors.postalCode && (
                      <Form.Text className="text-danger">
                        Enter your postal code
                      </Form.Text>
                    )}
                  </Form.Group>
                </Col>
                <Col md={6}>
                  <Form.Group>
                    <Form.Label>Country</Form.Label>
                    <Form.Control
                      type="text"
                      name="country"
                      value={country}
                      onChange={handleChange}
                      className={`px-3 ${
                        errors.country ? "border-danger mb-0" : ""
                      }`}
                      placeholder="Enter Country"
                    />
                    {errors.country && (
                      <Form.Text className="text-danger">
                        Enter your country
                      </Form.Text>
                    )}
                  </Form.Group>
                </Col>
              </Row>
            </div>
          </Modal.Body>
          <Modal.Footer className="border-0 pt-0">
            <Button
              variant="outline-danger"
              className="px-5"
              onClick={handleClose1}
            >
              Cancel
            </Button>
            <Button variant="success" type="submit" className="px-5">
              {formValues.id ? "Update" : "Save"}
            </Button>
          </Modal.Footer>
        </form>
        {loader ? (
          <ReactLoading
            type={"bars"}
            color="#33995e"
            height={60}
            width={60}
            className={"globe_loader"}
          />
        ) : (
          ""
        )}
      </Modal>
    </Container>
  );
}
